/**
 * Popular personal email domains
 * @see https://github.com/mailcheck/mailcheck/wiki/List-of-Popular-Domains
 */
export const PERSONAL_EMAIL_DOMAINS = new Set([
  /* Default domains included */
  'aol.com',
  'att.net',
  'comcast.net',
  'gmail.com',
  'gmx.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.co.uk',
  'mac.com',
  'me.com',
  'mail.com',
  'msn.com',
  'live.com',
  'sbcglobal.net',
  'verizon.net',
  'yahoo.com',
  'yahoo.co.uk',
  'windowslive.com',
  'yaho.com',
  'hey.com',

  /* Other global domains */
  'email.com',
  'fastmail.fm',
  'games.com' /* AOL */,
  'gmx.net',
  'hush.com',
  'hushmail.com',
  'icloud.com',
  'iname.com',
  'inbox.com',
  'lavabit.com',
  'love.com' /* AOL */,
  'outlook.com',
  'pobox.com',
  'protonmail.ch',
  'protonmail.com',
  'proton.me',
  'pm.me',
  'tutanota.de',
  'tutanota.com',
  'tutamail.com',
  'tuta.io',
  'keemail.me',
  'rocketmail.com' /* Yahoo */,
  'safe-mail.net',
  'wow.com' /* AOL */,
  'ygm.com' /* AOL */,
  'ymail.com' /* Yahoo */,
  'zoho.com',
  'yandex.com',

  /* United States ISP domains */
  'bellsouth.net',
  'charter.net',
  'cox.net',
  'earthlink.net',
  'juno.com',

  /* British ISP domains */
  'btinternet.com',
  'virginmedia.com',
  'blueyonder.co.uk',
  'freeserve.co.uk',
  'live.co.uk',
  'ntlworld.com',
  'o2.co.uk',
  'orange.net',
  'sky.com',
  'talktalk.co.uk',
  'tiscali.co.uk',
  'virgin.net',
  'wanadoo.co.uk',
  'bt.com',

  /* Domains used in Asia */
  'sina.com',
  'sina.cn',
  'qq.com',
  'naver.com',
  'hanmail.net',
  'daum.net',
  'nate.com',
  'yahoo.co.jp',
  'yahoo.co.kr',
  'yahoo.co.id',
  'yahoo.co.in',
  'yahoo.com.sg',
  'yahoo.com.ph',
  '163.com',
  'yeah.net',
  '126.com',
  '21cn.com',
  'aliyun.com',
  'foxmail.com',

  /* French ISP domains */
  'hotmail.fr',
  'live.fr',
  'laposte.net',
  'yahoo.fr',
  'wanadoo.fr',
  'orange.fr',
  'gmx.fr',
  'sfr.fr',
  'neuf.fr',
  'free.fr',

  /* German ISP domains */
  'gmx.de',
  'hotmail.de',
  'live.de',
  'online.de',
  't-online.de' /* T-Mobile */,
  'web.de',
  'yahoo.de',

  /* Italian ISP domains */
  'libero.it',
  'virgilio.it',
  'hotmail.it',
  'aol.it',
  'tiscali.it',
  'alice.it',
  'live.it',
  'yahoo.it',
  'email.it',
  'tin.it',
  'poste.it',
  'teletu.it',

  /* Russian ISP domains */
  'mail.ru',
  'rambler.ru',
  'yandex.ru',
  'ya.ru',
  'list.ru',

  /* Belgian ISP domains */
  'hotmail.be',
  'live.be',
  'skynet.be',
  'voo.be',
  'tvcablenet.be',
  'telenet.be',

  /* Argentinian ISP domains */
  'hotmail.com.ar',
  'live.com.ar',
  'yahoo.com.ar',
  'fibertel.com.ar',
  'speedy.com.ar',
  'arnet.com.ar',

  /* Domains used in Mexico */
  'yahoo.com.mx',
  'live.com.mx',
  'hotmail.es',
  'hotmail.com.mx',
  'prodigy.net.mx',

  /* Domains used in Canada */
  'yahoo.ca',
  'hotmail.ca',
  'bell.net',
  'shaw.ca',
  'sympatico.ca',
  'rogers.com',

  /* Domains used in Brazil */
  'yahoo.com.br',
  'hotmail.com.br',
  'outlook.com.br',
  'uol.com.br',
  'bol.com.br',
  'terra.com.br',
  'ig.com.br',
  'itelefonica.com.br',
  'r7.com',
  'zipmail.com.br',
  'globo.com',
  'globomail.com',
  'oi.com.br',

  /* Portugal */
  'outlook.pt',
]);

/**
 * Disposable email addresses
 *
 * On occasion, update this from (Last updated June 19, 2025)
 * @see https://github.com/disposable-email-domains/disposable-email-domains/blob/master/disposable_email_blocklist.conf
 */
export const DISPOSABLE_EMAIL_DOMAINS = new Set([
  'skygazerhub.com',
  'skyrt.de',
  'slapsfromlastnight.com',
  'slaskpost.se',
  'slave-auctions.net',
  'slippery.email',
  'slipry.net',
  'slopsbox.com',
  'slothmail.net',
  'slushmail.com',
  'sluteen.com',
  'sly.io',
  'smallker.tk',
  'smapfree24.com',
  'smapfree24.de',
  'smapfree24.eu',
  'smapfree24.info',
  'smapfree24.org',
  'smartemailbox.co',
  'smartnator.com',
  'smarttalent.pw',
  'smarttickethub.com',
  'smashmail.de',
  'smellfear.com',
  'smellrear.com',
  'smellypotato.tk',
  'smeux.com',
  'smncloud.com',
  'smtp99.com',
  'smwg.info',
  'smykwb.com',
  'snakebutt.com',
  'snakemail.com',
  'snapmail.cc',
  'snapmail.site',
  'snapwet.com',
  'sneakmail.de',
  'snece.com',
  'social-mailer.tk',
  'socialfurry.org',
  'sociallymediocre.com',
  'sofia.re',
  'sofimail.com',
  'sofort-mail.de',
  'sofortmail.de',
  'sofrge.com',
  'softkey-office.ru',
  'softpls.asia',
  'sogetthis.com',
  'sohai.ml',
  'sohus.cn',
  'soioa.com',
  'soisz.com',
  'solar-impact.pro',
  'solarnyx.com',
  'solvemail.info',
  'solventtrap.wiki',
  'somelora.com',
  'songsign.com',
  'sonshi.cf',
  'soodmail.com',
  'soodomail.com',
  'soodonims.com',
  'soombo.com',
  'soon.it',
  'soyboy.observer',
  'spacebazzar.ru',
  'spam-be-gone.com',
  'spam.care',
  'spam.ceo',
  'spam.la',
  'spam.org.es',
  'spam.su',
  'spam4.me',
  'spamail.de',
  'spamarrest.com',
  'spamavert.com',
  'spambob.com',
  'spambob.net',
  'spambob.org',
  'spambog.com',
  'spambog.de',
  'spambog.net',
  'spambog.ru',
  'spambooger.com',
  'spambox.info',
  'spambox.me',
  'spambox.org',
  'spambox.us',
  'spamcero.com',
  'spamcon.org',
  'spamcorptastic.com',
  'spamcowboy.com',
  'spamcowboy.net',
  'spamcowboy.org',
  'spamday.com',
  'spamdecoy.net',
  'spamex.com',
  'spamfellas.com',
  'spamfighter.cf',
  'spamfighter.ga',
  'spamfighter.gq',
  'spamfighter.ml',
  'spamfighter.tk',
  'spamfree.eu',
  'spamfree24.com',
  'spamfree24.de',
  'spamfree24.eu',
  'spamfree24.info',
  'spamfree24.net',
  'spamfree24.org',
  'spamgoes.in',
  'spamherelots.com',
  'spamhereplease.com',
  'spamhole.com',
  'spamify.com',
  'spaminator.de',
  'spamkill.info',
  'spaml.com',
  'spaml.de',
  'spamlot.net',
  'spammer.fail',
  'spammotel.com',
  'spammy.host',
  'spamobox.com',
  'spamoff.de',
  'spamsalad.in',
  'spamsandwich.com',
  'spamslicer.com',
  'spamsphere.com',
  'spamspot.com',
  'spamstack.net',
  'spamthis.co.uk',
  'spamthis.network',
  'spamthisplease.com',
  'spamtrail.com',
  'spamtrap.ro',
  'spamtroll.net',
  'spamwc.cf',
  'spamwc.ga',
  'spamwc.gq',
  'spamwc.ml',
  'speedgaus.net',
  'sperma.cf',
  'spicysoda.com',
  'spikio.com',
  'spindl-e.com',
  'spinly.net',
  'spoofmail.de',
  'sportrid.com',
  'spr.io',
  'spritzzone.de',
  'spruzme.com',
  'spybox.de',
  'spymail.com',
  'spymail.one',
  'squizzy.de',
  'squizzy.net',
  'sroff.com',
  'sry.li',
  'ssoia.com',
  'sssig.one',
  'stacys.mom',
  'stanfordujjain.com',
  'starlight-breaker.net',
  'starmail.net',
  'starpower.space',
  'startfu.com',
  'startkeys.com',
  'statdvr.com',
  'stathost.net',
  'statiix.com',
  'stayhome.li',
  'steam-area.ru',
  'steambot.net',
  'stexsy.com',
  'stinkefinger.net',
  'stop-my-spam.cf',
  'stop-my-spam.com',
  'stop-my-spam.ga',
  'stop-my-spam.ml',
  'stop-my-spam.pp.ua',
  'stop-my-spam.tk',
  'stopspam.app',
  'storiqax.top',
  'storj99.com',
  'storj99.top',
  'streetwisemail.com',
  'stromox.com',
  'stuckmail.com',
  'stuffmail.de',
  'stufmail.com',
  'stumpfwerk.com',
  'stylist-volos.ru',
  'submic.com',
  'suburbanthug.com',
  'suckmyd.com',
  'sudern.de',
  'sueshaw.com',
  'suexamplesb.com',
  'suioe.com',
  'super-auswahl.de',
  'superblohey.com',
  'supergreatmail.com',
  'supermailer.jp',
  'superplatyna.com',
  'superrito.com',
  'supersave.net',
  'superstachel.de',
  'superyp.com',
  'suremail.info',
  'sute.jp',
  'svetims.com',
  'svip520.cn',
  'svk.jp',
  'svxr.org',
  'sweetpotato.ml',
  'sweetxxx.de',
  'swift-mail.net',
  'swift10minutemail.com',
  'swsdz.com',
  'syinxun.com',
  'sylvannet.com',
  'symphonyresume.com',
  'synarca.com',
  'syncax.com',
  'syosetu.gq',
  'syujob.accountants',
  'szerz.com',
  'tacomail.de',
  'tafmail.com',
  'tafoi.gr',
  'taglead.com',
  'tagmymedia.com',
  'tagyourself.com',
  'taimb.com',
  'talkinator.com',
  'talmetry.com',
  'tanlanav.com',
  'tanukis.org',
  'taobudao.com',
  'tapchicuoihoi.com',
  'taphear.com',
  'tapi.re',
  'tartinemoi.com',
  'tarzanmail.cf',
  'tastrg.com',
  'tatsu.uk',
  'taugr.com',
  'taukah.com',
  'taxibmt.com',
  'tb-on-line.net',
  'tbgroupconsultants.com',
  'tcwlm.com',
  'tcwlx.com',
  'tdtda.com',
  'tech69.com',
  'techblast.ch',
  'techemail.com',
  'techgroup.me',
  'technoproxy.ru',
  'techusa.org',
  'teerest.com',
  'teewars.org',
  'tefl.ro',
  'telecomix.pl',
  'teleg.eu',
  'telegmail.com',
  'teleworm.com',
  'teleworm.us',
  'telimail.online',
  'tellos.xyz',
  'telvetto.com',
  'teml.net',
  'temp-link.net',
  'temp-mail.cfd',
  'temp-mail.com',
  'temp-mail.de',
  'temp-mail.org',
  'temp-mail.pp.ua',
  'temp-mail.ru',
  'temp-mails.com',
  'tempail.com',
  'tempalias.com',
  'tempe-mail.com',
  'tempemail.biz',
  'tempemail.co.za',
  'tempemail.com',
  'tempemail.net',
  'tempemailgen.com',
  'tempemaill.com',
  'tempinbox.co.uk',
  'tempinbox.com',
  'tempmail.cn',
  'tempmail.co',
  'tempmail.de',
  'tempmail.eu',
  'tempmail.id.vn',
  'tempmail.io.vn',
  'tempmail.it',
  'tempmail.pp.ua',
  'tempmail.us',
  'tempmail.ws',
  'tempmail2.com',
  'tempmaildemo.com',
  'tempmailer.com',
  'tempmailer.de',
  'tempmailer.net',
  'tempmailfree.net',
  'tempmailo.com',
  'tempmailyo.org',
  'tempomail.fr',
  'tempomail.org',
  'temporarily.de',
  'temporarioemail.com.br',
  'temporary-mail.net',
  'temporaryemail.net',
  'temporaryemail.us',
  'temporaryforwarding.com',
  'temporaryinbox.com',
  'temporarymailaddress.com',
  'temppppo.store',
  'tempr.email',
  'tempsky.com',
  'temptami.com',
  'tempthe.net',
  'tempymail.com',
  'tensi.org',
  'tenull.com',
  'ternaklele.ga',
  'testore.co',
  'testudine.com',
  'tevstart.com',
  'tgduck.com',
  'thanksnospam.info',
  'thankyou2010.com',
  'thatim.info',
  'thc.st',
  'the23app.com',
  'theaviors.com',
  'thebearshark.com',
  'thecarinformation.com',
  'thechildrensfocus.com',
  'thecity.biz',
  'thecloudindex.com',
  'thediamants.org',
  'thedirhq.info',
  'theeyeoftruth.com',
  'thejoker5.com',
  'thelightningmail.net',
  'thelimestones.com',
  'thembones.com.au',
  'themegreview.com',
  'themostemail.com',
  'thereddoors.online',
  'theroyalweb.club',
  'thescrappermovie.com',
  'thespamfather.com',
  'theteastory.info',
  'thetechnext.net',
  'thex.ro',
  'thichanthit.com',
  'thietbivanphong.asia',
  'thirifara.com',
  'thisisnotmyrealemail.com',
  'thismail.net',
  'thisurl.website',
  'thnikka.com',
  'thoas.ru',
  'thraml.com',
  'thrma.com',
  'throam.com',
  'thrott.com',
  'throwam.com',
  'throwawayemailaddress.com',
  'throwawaymail.com',
  'throwawaymail.pp.ua',
  'throya.com',
  'thrubay.com',
  'thunderbolt.science',
  'thunkinator.org',
  'thxmate.com',
  'tiapz.com',
  'tic.ec',
  'tidissajiiu.com',
  'tikanony.com',
  'tilien.com',
  'timgiarevn.com',
  'timkassouf.com',
  'tinoza.org',
  'tinyurl24.com',
  'tipsb.com',
  'tittbit.in',
  'tiv.cc',
  'tizi.com',
  'tkitc.de',
  'tlpn.org',
  'tmail.com',
  'tmail.io',
  'tmail.link',
  'tmail.ws',
  'tmail3.com',
  'tmail9.com',
  'tmaile.net',
  'tmailinator.com',
  'tmails.net',
  'tmmbt.net',
  'tmpbox.net',
  'tmpemails.com',
  'tmpeml.com',
  'tmpeml.info',
  'tmpjr.me',
  'tmpmail.net',
  'tmpmail.org',
  'tmpmailtor.com',
  'tmpnator.live',
  'tmpx.sa.com',
  'tnbeta.com',
  'toddsbighug.com',
  'tofeat.com',
  'tohru.org',
  'toiea.com',
  'tokem.co',
  'token.ro',
  'tokenmail.de',
  'tonaeto.com',
  'tonne.to',
  'tonymanso.com',
  'too.li',
  'toolbox.ovh',
  'toomail.biz',
  'toon.ml',
  'top-shop-tovar.ru',
  'top101.de',
  'top1mail.ru',
  'top1post.ru',
  'topdatamaster.com',
  'topinrock.cf',
  'topmail2.com',
  'topmail2.net',
  'topofertasdehoy.com',
  'topranklist.de',
  'toprumours.com',
  'topvu.net',
  'tormail.org',
  'tospage.com',
  'toss.pw',
  'tosunkaya.com',
  'totallynotfake.net',
  'totalvista.com',
  'totesmail.com',
  'totoan.info',
  'tourcc.com',
  'tp-qa-mail.com',
  'tpwlb.com',
  'tqoai.com',
  'tqosi.com',
  'trackden.com',
  'tradermail.info',
  'tranceversal.com',
  'translateid.com',
  'trap-mail.de',
  'trash-amil.com',
  'trash-mail.at',
  'trash-mail.cf',
  'trash-mail.com',
  'trash-mail.de',
  'trash-mail.ga',
  'trash-mail.gq',
  'trash-mail.ml',
  'trash-mail.tk',
  'trash-me.com',
  'trash2009.com',
  'trash2010.com',
  'trash2011.com',
  'trashcanmail.com',
  'trashdevil.com',
  'trashdevil.de',
  'trashemail.de',
  'trashemails.de',
  'trashinbox.com',
  'trashmail.at',
  'trashmail.com',
  'trashmail.de',
  'trashmail.gq',
  'trashmail.io',
  'trashmail.me',
  'trashmail.net',
  'trashmail.org',
  'trashmail.ws',
  'trashmailer.com',
  'trashmailgenerator.de',
  'trashmails.com',
  'trashymail.com',
  'trashymail.net',
  'trasz.com',
  'trayna.com',
  'trbvm.com',
  'trbvn.com',
  'trbvo.com',
  'trend-maker.ru',
  'trfu.to',
  'trgfu.com',
  'trgovinanaveliko.info',
  'trialmail.de',
  'trickmail.net',
  'trillianpro.com',
  'triots.com',
  'trixtrux1.ru',
  'trollproject.com',
  'tropicalbass.info',
  'trungtamtoeic.com',
  'truthfinderlogin.com',
  'tryalert.com',
  'tryninja.io',
  'tryzoe.com',
  'tsderp.com',
  'ttirv.org',
  'ttszuo.xyz',
  'tualias.com',
  'tuofs.com',
  'tupmail.com',
  'turoid.com',
  'turual.com',
  'turuma.com',
  'tutuapp.bid',
  'tvchd.com',
  'tverya.com',
  'twinmail.de',
  'twkly.ml',
  'twocowmail.net',
  'twoweirdtricks.com',
  'twzhhq.online',
  'txcct.com',
  'txen.de',
  'txtadvertise.com',
  'tyhe.ro',
  'tyldd.com',
  'tympe.net',
  'uacro.com',
  'uber-mail.com',
  'ubinert.com',
  'ubismail.net',
  'ubm.md',
  'ucche.us',
  'ucupdong.ml',
  'uemail99.com',
  'ufacturing.com',
  'uggsrock.com',
  'uguuchantele.com',
  'uhe2.com',
  'uhhu.ru',
  'uiu.us',
  'ujijima1129.gq',
  'uk.to',
  'ukm.ovh',
  'ultra.fyi',
  'ultrada.ru',
  'uma3.be',
  'umail.net',
  'umil.net',
  'undeadbank.com',
  'underseagolf.com',
  'undo.it',
  'unicodeworld.com',
  'unids.com',
  'unimark.org',
  'unit7lahaina.com',
  'universall.me',
  'unmail.ru',
  'unratito.com',
  'uooos.com',
  'uorak.com',
  'upliftnow.com',
  'uplipht.com',
  'uploadnolimit.com',
  'upozowac.info',
  'urfunktion.se',
  'urhen.com',
  'uroid.com',
  'us.af',
  'us.to',
  'usa.cc',
  'usako.net',
  'usbc.be',
  'usdtbeta.com',
  'used-product.fr',
  'ushijima1129.cf',
  'ushijima1129.ga',
  'ushijima1129.gq',
  'ushijima1129.ml',
  'ushijima1129.tk',
  'usm.ovh',
  'utiket.us',
  'uu.gl',
  'uu2.ovh',
  'uuf.me',
  'uuii.in',
  'uwork4.us',
  'uyhip.com',
  'uz8.net',
  'vaasfc4.tk',
  'vaati.org',
  'vafyxh.com',
  'valemail.net',
  'valhalladev.com',
  'vankin.de',
  'vasteron.com',
  'vcois.com',
  'vctel.com',
  'vda.ro',
  'vddaz.com',
  'vdig.com',
  'veanlo.com',
  'veb37.com',
  'veltexline.com',
  'vemomail.win',
  'venompen.com',
  'veo.kr',
  'ver0.cf',
  'ver0.ga',
  'ver0.gq',
  'ver0.ml',
  'ver0.tk',
  'vercelli.cf',
  'vercelli.ga',
  'vercelli.gq',
  'vercelli.ml',
  'verdejo.com',
  'vermutlich.net',
  'veryday.ch',
  'veryday.eu',
  'veryday.info',
  'veryrealemail.com',
  'ves.ink',
  'vesa.pw',
  'vetra.cyou',
  'vevs.de',
  'vexi.my',
  'via.tokyo.jp',
  'vibzi.net',
  'vickaentb.tk',
  'victime.ninja',
  'victoriantwins.com',
  'vidchart.com',
  'viditag.com',
  'vidwobox.com',
  'viewcastmedia.com',
  'viewcastmedia.net',
  'viewcastmedia.org',
  'vigilantkeep.net',
  'vikingsonly.com',
  'vinernet.com',
  'vintomaper.com',
  'vipepe.com',
  'vipmail.name',
  'vipmail.pw',
  'vips.pics',
  'vipxm.net',
  'viralplays.com',
  'virtualemail.info',
  'visal007.tk',
  'visal168.cf',
  'visal168.ga',
  'visal168.gq',
  'visal168.ml',
  'visal168.tk',
  'visignal.com',
  'viv2.com',
  'vixletdev.com',
  'vixtricks.com',
  'vjoid.ru',
  'vjoid.store',
  'vjuum.com',
  'vkbb.ru',
  'vkbb.store',
  'vkbt.ru',
  'vkbt.store',
  'vkcbt.ru',
  'vkcbt.store',
  'vkcode.ru',
  'vkfu.ru',
  'vkfu.store',
  'vkpr.store',
  'vkr1.com',
  'vkrr.ru',
  'vkrr.store',
  'vlemi.com',
  'vmailing.info',
  'vmani.com',
  'vmpanda.com',
  'vncctv.org',
  'vnedu.me',
  'voidbay.com',
  'volaj.com',
  'volku.org',
  'voltaer.com',
  'vomoto.com',
  'vorga.org',
  'votiputox.org',
  'voxelcore.com',
  'voxinh.net',
  'vpn.st',
  'vps30.com',
  'vps911.net',
  'vradportal.com',
  'vremonte24-store.ru',
  'vrmtr.com',
  'vsimcard.com',
  'vssms.com',
  'vtxmail.us',
  'vubby.com',
  'vuiy.pw',
  'vuket.org',
  'vulca.sbs',
  'vusra.com',
  'vvatxiy.com',
  'vwhins.com',
  'vxsolar.com',
  'vztc.com',
  'w-asertun.ru',
  'w3internet.co.uk',
  'waivey.com',
  'wakingupesther.com',
  'walala.org',
  'walkmail.net',
  'walkmail.ru',
  'wallm.com',
  'wanko.be',
  'watch-harry-potter.com',
  'watchever.biz',
  'watchfull.net',
  'watchironman3onlinefreefullmovie.com',
  'waterisgone.com',
  'watrf.com',
  'wazabi.club',
  'wbdev.tech',
  'wbml.net',
  'web-contact.info',
  'web-ideal.fr',
  'web-inc.net',
  'web-mail.pp.ua',
  'web2mailco.com',
  'webcontact-france.eu',
  'webemail.me',
  'webhook.site',
  'webm4il.info',
  'webmail24.top',
  'webofip.com',
  'webscash.com',
  'webtrip.ch',
  'webuser.in',
  'wecp.ru',
  'wecp.store',
  'wee.my',
  'weekfly.com',
  'wef.gr',
  'weg-werf-email.de',
  'wegwerf-email-addressen.de',
  'wegwerf-email-adressen.de',
  'wegwerf-email.at',
  'wegwerf-email.de',
  'wegwerf-email.net',
  'wegwerf-emails.de',
  'wegwerfadresse.de',
  'wegwerfemail.com',
  'wegwerfemail.de',
  'wegwerfemail.info',
  'wegwerfemail.net',
  'wegwerfemail.org',
  'wegwerfemailadresse.com',
  'wegwerfmail.de',
  'wegwerfmail.info',
  'wegwerfmail.net',
  'wegwerfmail.org',
  'wegwrfmail.de',
  'wegwrfmail.net',
  'wegwrfmail.org',
  'weizixu.com',
  'wekawa.com',
  'welikecookies.com',
  'wellsfargocomcardholders.com',
  'wemel.top',
  'wenkuu.com',
  'wentcity.com',
  'wetrainbayarea.com',
  'wetrainbayarea.org',
  'wfgdfhj.tk',
  'wg0.com',
  'wh4f.org',
  'whaaaaaaaaaat.com',
  'whatagarbage.com',
  'whatiaas.com',
  'whatifanalytics.com',
  'whatpaas.com',
  'whatsaas.com',
  'whiffles.org',
  'whopy.com',
  'whyspam.me',
  'wibblesmith.com',
  'wickmail.net',
  'widaryanto.info',
  'widget.gg',
  'wiemei.com',
  'wierie.tk',
  'wifimaple.com',
  'wifioak.com',
  'wikfee.com',
  'wikidocuslava.ru',
  'wilemail.com',
  'willhackforfood.biz',
  'willselfdestruct.com',
  'wimsg.com',
  'winemaven.info',
  'winocs.com',
  'wins.com.br',
  'wir-sind.com',
  'wishy.fr',
  'wlist.ro',
  'wlsom.com',
  'wmail.cf',
  'wmail.club',
  'wokcy.com',
  'wolfmail.ml',
  'wolfsmail.tk',
  'wollan.info',
  'womp-wo.mp',
  'worldspace.link',
  'wpdork.com',
  'wpg.im',
  'wralawfirm.com',
  'writeme.us',
  'wronghead.com',
  'ws.gy',
  'wsym.de',
  'wudet.men',
  'wuespdj.xyz',
  'wupics.com',
  'wuuvo.com',
  'wuzak.com',
  'wuzup.net',
  'wuzupmail.net',
  'wwc8.com',
  'wwjmp.com',
  'wwvk.ru',
  'wwvk.store',
  'wwwnew.eu',
  'wxnw.net',
  'wyoxafp.com',
  'wywnxa.com',
  'wzofit.com',
  'x-lab.net',
  'x24.com',
  'xagloo.co',
  'xagloo.com',
  'xbaby69.top',
  'xcode.ro',
  'xcodes.net',
  'xcompress.com',
  'xcoxc.com',
  'xcpy.com',
  'xemaps.com',
  'xemne.com',
  'xenta.cfd',
  'xents.com',
  'xepa.ru',
  'xidealx.com',
  'xjoi.com',
  'xkx.me',
  'xl.cx',
  'xmail.com',
  'xmailer.be',
  'xmailtm.com',
  'xmaily.com',
  'xn--9kq967o.com',
  'xn--d-bga.net',
  'xojxe.com',
  'xost.us',
  'xoxox.cc',
  'xperiae5.com',
  'xrap.de',
  'xrho.com',
  'xstyled.net',
  'xvx.us',
  'xww.ro',
  'xxhamsterxx.ga',
  'xxi2.com',
  'xxl.st',
  'xxlocanto.us',
  'xxolocanto.us',
  'xxqx3802.com',
  'xxvk.ru',
  'xxvk.store',
  'xxxhi.cc',
  'xy9ce.tk',
  'xylar.ru',
  'xylar.store',
  'xyzfree.net',
  'xzsok.com',
  'yabai-oppai.tk',
  'yabes.ovh',
  'yahmail.top',
  'yahooproduct.net',
  'yamail.win',
  'yanet.me',
  'yannmail.win',
  'yapped.net',
  'yaqp.com',
  'yarnpedia.ga',
  'ycare.de',
  'ycn.ro',
  'ye.vc',
  'yecp.ru',
  'yecp.store',
  'yedi.org',
  'yeezus.ru',
  'yep.it',
  'yermail.net',
  'yhg.biz',
  'ynmrealty.com',
  'yodx.ro',
  'yogamaven.com',
  'yoggm.com',
  'yomail.info',
  'yoo.ro',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.gq',
  'yopmail.net',
  'yopmail.pp.ua',
  'yordanmail.cf',
  'you-spam.com',
  'yougotgoated.com',
  'youmail.ga',
  'youmailr.com',
  'youneedmore.info',
  'youpymail.com',
  'your5.ru',
  'your5.store',
  'yourdomain.com',
  'youremail.cf',
  'yourewronghereswhy.com',
  'yourlms.biz',
  'yourspamgoesto.space',
  'yourtube.ml',
  'youxiang.dev',
  'yroid.com',
  'yspend.com',
  'ytnhy.com',
  'ytpayy.com',
  'yugasandrika.com',
  'yui.it',
  'yun.pics',
  'yuoia.com',
  'yuurok.com',
  'ywzmb.top',
  'yxdad.ru',
  'yxdad.store',
  'yxzx.net',
  'yyolf.net',
  'z-o-e-v-a.ru',
  'z0d.eu',
  'z1p.biz',
  'z86.ru',
  'zain.site',
  'zainmax.net',
  'zaktouni.fr',
  'zarabotokdoma11.ru',
  'zasod.com',
  'zaym-zaym.ru',
  'zcovz.ru',
  'zcovz.store',
  'zcrcd.com',
  'zdenka.net',
  'ze.tc',
  'zebins.com',
  'zebins.eu',
  'zehnminuten.de',
  'zehnminutenmail.de',
  'zemzar.net',
  'zepp.dk',
  'zetmail.com',
  'zfymail.com',
  'zhaoqian.ninja',
  'zhaoyuanedu.cn',
  'zhcne.com',
  'zhewei88.com',
  'zhorachu.com',
  'zik.dj',
  'zipcad.com',
  'zipcatfish.com',
  'zipo1.gq',
  'zippymail.info',
  'zipsendtest.com',
  'zira.my',
  'ziragold.com',
  'zivox.sbs',
  'zizo7.com',
  'zoaxe.com',
  'zoemail.com',
  'zoemail.net',
  'zoemail.org',
  'zoetropes.org',
  'zombie-hive.com',
  'zomg.info',
  'zsero.com',
  'zudpck.com',
  'zumpul.com',
  'zv68.com',
  'zvvzuv.com',
  'zx81.ovh',
  'zxcv.com',
  'zxcvbnm.com',
  'zymuying.com',
  'zyns.com',
  'zzi.us',
  'zzrgg.com',
  'zzz.com',
]);
